import { Modal } from '@investoro/core';

export default Modal;
